<template>
  <div class="w-full h-full">
    <el-page-header @back="goback" content="培训须知"></el-page-header>
    <div class="fz-16 pl-20px pb-20px pt-20px mt-20px bg-hex-f7f9fa" style="line-height:30px">
      <div>1、厂内作业有较多的风险因素,请认真学习培训内容;</div>
      <div>
        2、审核通过的人员,允许参加的培训课程,培训人需要通过全部的必修课程,且获得要求的学分、学时,才可以通过培训课程;
      </div>
      <div>3、每个培训课件内,都包含多个节点,视频学习进度到达时,可以答题完成节点;</div>
      <div>4、未完成的节点不可快进跳过,未完成的节点进度不会保存,请谨慎退出;</div>
      <div>5、培训通过后,请在首页参加入厂考试,完成此阶段的培训考试;</div>
      <div>6、未完成培训流程的员工将禁止入厂作业;</div>
    </div>
    <div class="el-step__arrow card-header-my m-t-30">
      <el-button type="primary" @click="statrTest" :disabled="timeFlage">
        开始培训<span v-if="timeFlage">{{ `${timeCount}s` }}</span></el-button
      >
      <!-- <el-button @click="goback"> 取消</el-button> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentTrainObj: {
      type: Object,
      default: () => {
        return {}
      },
    },
    isNeedReplaceRoute: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      timeCount: 5,
      timeFlage: true,
      timer: '',
    }
  },
  created() {
    this.count()
  },
  methods: {
    statrTest() {
      const url = Wiz?.globalSettings?.globalConfig?.routerBase
        ? `/${Wiz.globalSettings.globalConfig.routerBase}/educational-training-management-sm/train-manage/training`
        : '/educational-training-management-sm/train-manage/training'
      this.$router.push({
        path: url,
        query: {
          id: this.currentTrainObj.id,
          status: this.currentTrainObj.status,
          isNeedReplaceRoute: this.isNeedReplaceRoute,
        },
      })
    },
    count() {
      this.timer = setInterval(() => {
        this.timeCount -= 1
        if (this.timeCount === 0) {
          this.timeFlage = false
          clearInterval(this.timer)
        }
      }, 1000)
    },
    goback() {
      this.timer && clearInterval(this.timer)
      this.$emit('cancell')
    },
  },
}
</script>

<style lang="scss" scoped>
.el-icon-loading:before {
  font-size: 100px;
}
.result {
  margin-top: 100px;
}
.danger-color {
  color: red;
}
.hand_test {
  float: right;
}
.card-header-my {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0.75rem;
}
</style>
